import { Action, createAction, props } from "@ngrx/store";
import { User } from "../models/user.model";

export const userDetails = createAction(
    '[User details] retrieve loggedIn user details',props<{user:ReadonlyArray<User> }>()
)

export const impersonateAction = createAction(
    'Change user impersonation mode', props<{ impersonate: boolean }>()
)